<template>
  <v-card flat v-if="campaign.campaign_id">
    <v-card-title class="px-6">
      <!-- <span class="font-italic  text-h4" style="position: absolute;">#{{ campaign.campaign_id }}</span> -->
      <v-col cols="12 d-flex justify-center align-center font-weight-medium text-h4"
        ><span>
          <span class="text-h5 font-weight-regular mb-n2 text-right" :style="{ minWidth: '150px' }"
            >#{{ campaign.campaign_id }}</span
          >
          <v-divider class="ma-4" vertical></v-divider>
          <span class=""> {{ campaign.title }}</span>
        </span>
      </v-col>
      <v-spacer></v-spacer>
    </v-card-title>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" :style="{ height: '10px' }"></th>
            <th class="text-left" :style="{ height: '10px' }"></th>
          </tr>
        </thead>
        <tbody>
          <tr></tr>
          <tr>
            <td>{{ translations.campaignId[lang] }}</td>
            <td>{{ campaign.campaign_id }}</td>
          </tr>
          <tr>
            <td>{{ translations.title[lang] }}</td>
            <td>{{ campaign.title }}</td>
          </tr>
          <tr>
            <td>{{ translations.status[lang] }}</td>
            <td>
              <span class="font-weight-bold px-1" v-text="currentStatus.name[lang]"></span>
              <v-tooltip color="secondary" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="secondary"
                    class="text-capitalize px-5"
                    v-on="on"
                    depressed
                    icon
                    @click="openStatusDialog()"
                    :disabled="currentStatus.system == 'completed'"
                  >
                    <v-icon v-text="icons.mdiCached"></v-icon>
                  </v-btn>
                </template>

                <span class="font-weight-bold" v-text="translations.changeStatus[lang]"></span>
              </v-tooltip>
            </td>
          </tr>
          <tr>
            <td>{{ translations.notifications[lang] }}</td>
            <td>
              <div v-if="(campaign.system_notification_ids || []).length" class="d-flex">
                <span
                  v-for="(notification, index) in currentNotifications"
                  :key="index"
                  class="font-weight-bold px-1 d-flex align-center pr-0"
                >
                  <v-icon
                    v-if="index && campaign.notifier_type && campaign.notifier_type == 'priority'"
                    size="15"
                    v-text="icons.mdiArrowRight"
                    color="secondary"
                  ></v-icon>
                  <Icon
                    v-if="notification.channel == 'viber'"
                    icon="simple-icons:viber"
                    color="secondary"
                    :style="{
                      fontSize: '20px',
                    }"
                  />
                  <v-icon
                    v-else
                    v-text="notificationIcons[notification.channel]"
                    color="secondary"
                  ></v-icon>
                </span>
              </div>
              <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
            </td>
          </tr>
          <tr>
            <td style="width: 50%">
              {{ translations.billableText[lang] }}
            </td>
            <td>
              <div class="d-flex align-start, justify-start">
                <v-icon
                  v-if="campaign.billable_notifications"
                  v-text="icons.mdiCheckCircle"
                  color="green"
                ></v-icon>
                <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
                <div v-if="superUser" class="ml-2">
                  <v-tooltip v-if="campaign.billable_notifications" color="secondary" top>
                    <template v-slot:activator="{ on }">
                      <v-btn class="mr-4" icon v-on="on" @click="verifyUpdateBilling(false)">
                        <v-icon v-text="icons.mdiCashRemove"></v-icon>
                      </v-btn>
                    </template>
                    <span class="font-weight-bold" v-text="translations.cancelBilling[lang]"></span>
                  </v-tooltip>
                  <v-tooltip v-else color="secondary" top>
                    <template v-slot:activator="{ on }">
                      <v-btn class="mr-4" icon v-on="on" @click="verifyUpdateBilling(true)">
                        <v-icon v-text="icons.mdiCashCheck"></v-icon>
                      </v-btn>
                    </template>
                    <span
                      class="font-weight-bold"
                      v-text="translations.confirmBilling[lang]"
                    ></span>
                  </v-tooltip>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>{{ translations.hasReward[lang] }}</td>
            <td>
              <v-icon v-if="hasReward" v-text="icons.mdiCheckCircle" color="green"></v-icon>
              <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
            </td>
          </tr>
          <tr>
            <td>{{ translations.totalParticipants[lang] }}</td>
            <td>{{ campaign.total_participants || 0 }}</td>
          </tr>
          <tr v-if="campaign.activated_at">
            <td>{{ translations.activatedAt[lang] }}</td>
            <td>{{ localizeDate(campaign.activated_at) }}</td>
          </tr>
          <tr>
            <td>{{ translations.createdAt[lang] }}</td>
            <td>{{ localizeDate(campaign.created_at) }}</td>
          </tr>
          <tr :style="{ background: '#eaedf1' }">
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-row>
      <v-col cols="12" md="12" class="d-flex align-center">
        <span class="text-h5 pa-6 pl-12 pb-0"
          >{{ translations.campaignType[lang] }}
          <v-tooltip color="secondary" top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="ml-1"
                color="secondary darken-3"
                icon
                v-on="on"
                @click="openTypeOptionsDialog()"
              >
                <v-icon v-text="icons.mdiCogSync"></v-icon>
              </v-btn>
            </template>
            <span
              class="font-weight-bold"
              v-text="translations.changeTypeOptions[lang]"
            ></span> </v-tooltip
        ></span>
      </v-col>
      <v-col cols="12" md="12" class="">
        <v-simple-table v-if="campaignType.value.system">
          <template v-slot:default>
            <thead :style="{ maxHeight: '1px' }">
              <tr>
                <th class="text-left" :style="{ height: '1px' }"></th>
                <th class="text-left" :style="{ height: '1px' }"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ translations.category[lang] }}</td>
                <td>
                  <span class="font-weight-bold px-1 d-flex align-center pr-0">
                    <v-icon v-text="icons.types[campaignType.name]" color="secondary"></v-icon
                    ><span v-if="campaignType.name" class="ml-1 mr-3">{{
                      translations[campaignType.name][lang]
                    }}</span>
                    <v-icon
                      class="mr-3"
                      size="20"
                      v-text="icons.mdiArrowRight"
                      color="secondary"
                    ></v-icon>
                    <v-icon
                      v-text="icons.types[campaignType.value.system]"
                      color="secondary"
                    ></v-icon
                    ><span class="ml-1">{{ translations[campaignType.value.system][lang] }}</span>
                  </span>
                </td>
              </tr>
              <tr v-if="repeatDays.length">
                <td>{{ translations.days[lang] }}</td>
                <td>
                  <v-row class="d-flex justify-start ml-0 transition-all mw-100">
                    <v-col
                      v-for="(item, index) in repeatDays"
                      :key="index"
                      cols="12"
                      sm="12"
                      md="4"
                      class="d-flex flex-row justify-center align-center mt-0 pa-5 pt-2 pb-2 transition-all text-caption rounded-lg text-left mr-0"
                      :style="{
                        maxWidth: '120px',
                        maxHeight: '150px',
                        lineHeight: '0.75rem',
                      }"
                    >
                      <v-divider
                        v-if="index"
                        vertical
                        :style="{
                          minHeight: '66%',
                          alignSelf: 'center',
                        }"
                        class="mr-1 ml-1"
                      ></v-divider>
                      <span class="pa-1"
                        ><span v-if="item.day"></span>{{ translations[item.day.name][lang] }}({{
                          item.time
                        }})</span
                      >
                    </v-col>
                  </v-row>
                </td>
              </tr>
              <tr v-if="campaign.campaign_type_id_options.date">
                <td>{{ translations.selectedDate[lang] }}</td>
                <td>
                  {{ localizeDate(campaign.campaign_type_id_options.date) }}
                </td>
              </tr>
              <tr v-if="campaign.campaign_type_id_options.time">
                <td>{{ translations.selectedTime[lang] }}</td>
                <td>
                  {{ campaign.campaign_type_id_options.time }}
                </td>
              </tr>

              <tr
                v-if="
                  campaign.campaign_type_id_options[0] && campaign.campaign_type_id_options[0].date
                "
              >
                <td>{{ translations.selectedDates[lang] }}</td>
                <td>
                  <div v-for="(item, index) in campaign.campaign_type_id_options" :key="index">
                    <span>{{ localizeDate(item.date) }} - {{ item.time }}</span>
                  </div>
                </td>
              </tr>
              <tr v-if="campaign.campaign_type_id_options.goal">
                <td>{{ translations.goalType[lang] }}</td>
                <td>
                  <span class="text-capitalize">{{
                    campaign.campaign_type_id_options.goal.type
                  }}</span>
                </td>
              </tr>

              <tr v-if="campaign.campaign_type_id_options.goal">
                <td>{{ translations.goalCounter[lang] }}</td>
                <td>
                  <span>{{ campaign.campaign_type_id_options.goal.counter }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  campaign.campaign_type_id_options.transaction_types &&
                  campaign.campaign_type_id_options.transaction_types[0]
                "
              >
                <td>
                  {{ translations.transactionTypes[lang] }}
                </td>
                <td>
                  <v-row class="d-flex justify-start ml-0 transition-all mw-100">
                    <v-col
                      v-for="(item, index) in campaign.campaign_type_id_options.transaction_types"
                      :key="index"
                      cols="12"
                      sm="12"
                      md="4"
                      class="d-flex flex-row justify-center align-center mt-0 pa-5 pt-2 pb-2 transition-all text-caption rounded-lg text-left mr-0"
                      :style="{
                        maxWidth: '120px',
                        maxHeight: '150px',
                        lineHeight: '0.75rem',
                      }"
                    >
                      <!-- <span v-if="index">  -->
                      <v-divider
                        v-if="index"
                        vertical
                        :style="{
                          minHeight: '66%',
                          alignSelf: 'center',
                        }"
                        class="mr-1 ml-1"
                      ></v-divider>
                      <!-- </span> -->
                      <v-icon
                        v-text="transactionTypesIcons[item.transaction_id]"
                        size="35"
                        color="secondary"
                      ></v-icon>
                      <span class="pa-1">{{ item.name[lang] }}</span>

                      <!-- <v-sheet
                                    class=" rounded-circle pa-0 text-center  mw-100 text-subtitle-2 border-grey mt-n5"
                                >
                                    <v-icon
                                        class="ma-5 text-subtitle-1"
                                        size="25"
                                        v-text="
                                            transactionTypesIcons[
                                                item.transaction_id
                                            ]
                                        "
                                    ></v-icon>
                                </v-sheet>
                                <div
                                    class="pt-1 text-center mb-n5 text-body-2"
                                    style="min-width: 135%;"
                                >
                                    {{ item.name[lang] }}
                                </div> -->
                    </v-col>
                  </v-row>
                </td>
              </tr>

              <tr v-for="(key, i) in Object.keys(campaignProducts)" :key="i">
                <td>
                  {{ translations.products[lang] }}
                  <span v-if="key != 'x0'">{{ key }}</span>
                </td>
                <td>
                  <div class="d-flex">
                    <v-row
                      v-if="campaignProducts[key] != '*'"
                      class="d-flex justify-start ml-0 transition-all mw-100"
                    >
                      <v-col
                        v-for="(item, index) in campaignProducts[key]"
                        :key="index"
                        cols="12"
                        sm="12"
                        md="4"
                        class="d-flex flex-row justify-center align-center mt-0 pa-5 pt-2 pb-2 transition-all text-caption rounded-lg text-left mr-0"
                        :class="[index > 3 && 'display-none']"
                        :style="{
                          maxWidth: '120px',
                          maxHeight: '150px',
                          lineHeight: '0.75rem',
                        }"
                      >
                        <v-divider
                          v-if="index && index < 3"
                          vertical
                          :style="{
                            minHeight: '66%',
                            alignSelf: 'center',
                          }"
                          class="mr-1 ml-1"
                        ></v-divider>
                        <v-img
                          v-if="
                            item.image !=
                              'https://roadcube-stage-files.s3.eu-central-1.amazonaws.com/images/info/rc/no-image.png' &&
                            index < 3
                          "
                          contain
                          height="42"
                          width="42"
                          max-height="48"
                          max-width="48"
                          :src="item.image"
                          aspect-ratio="1"
                          class="grey lighten-2"
                        ></v-img>
                        <span v-if="index < 3" class="pa-1">{{ item.name[lang] }}</span>
                        <v-btn
                          v-if="index === 3"
                          class="ml-2"
                          color="secondary"
                          fab
                          x-small
                          dark
                          @click="
                            openList(campaign.campaign_type_id_options.products, {
                              title: translations.products[lang],
                              nameField: 'name',
                            })
                          "
                        >
                          <v-icon>...</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <span v-else>{{ translations.all[lang] }} </span>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  campaign.campaign_type_id_options.stores &&
                  campaign.campaign_type_id_options.stores[0]
                "
              >
                <td>
                  {{ translations.selectedStores[lang] }}
                </td>
                <td>
                  <div class="d-flex">
                    <v-row
                      v-if="campaign.campaign_type_id_options.stores != '*'"
                      class="d-flex justify-start ml-0 transition-all mw-100"
                    >
                      <v-col
                        v-for="(item, index) in campaign.campaign_type_id_options.stores"
                        :key="index"
                        cols="12"
                        sm="12"
                        md="4"
                        class="d-flex flex-row justify-center align-center mt-0 pa-2 pl-0 pr-0 transition-all text-caption rounded-lg text-left mr-0"
                        :class="[index > 3 && 'display-none']"
                        :style="{
                          maxWidth: '120px',
                          maxHeight: '150px',
                          lineHeight: '0.75rem',
                        }"
                      >
                        <v-divider
                          v-if="index && index < 3"
                          vertical
                          :style="{
                            minHeight: '66%',
                            alignSelf: 'center',
                          }"
                          class="mr-auto ml-auto"
                        ></v-divider>
                        <span v-if="index < 3" class="pa-1 font-weight-medium text-center"
                          ><div class="pa-1 pb-2 pt-0 font-weight-light" v-if="item.store_code">
                            [{{ item.store_code }}]
                          </div>
                          {{ item.name }}</span
                        >
                        <v-btn
                          v-if="index == 3"
                          class="ml-2"
                          color="secondary"
                          fab
                          x-small
                          dark
                          @click="
                            openList(campaign.campaign_type_id_options.stores, {
                              title: translations.selectedStores[lang],
                            })
                          "
                        >
                          <v-icon>...</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <span v-else
                      >{{ translations.all[lang] }}
                      <!-- <v-btn
                                            color="secondary"
                                            dark
                                            class="ml-2"
                                            small
                                            @click="openList()"
                                            >{{ translations.more[lang] }}</v-btn
                                        > -->
                    </span>
                  </div>
                </td>
              </tr>

              <tr v-if="campaign.campaign_type_id_options.start_date">
                <td>{{ translations.startDate[lang] }}</td>
                <td>
                  <span>{{ localizeDate(campaign.campaign_type_id_options.start_date) }}</span>
                </td>
              </tr>
              <tr v-if="campaign.campaign_type_id_options.end_date">
                <td>{{ translations.endDate[lang] }}</td>
                <td>
                  <span>{{ localizeDate(campaign.campaign_type_id_options.end_date) }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  campaign.campaign_type_id_options.from_hour &&
                  campaign.campaign_type_id_options.to_hour
                "
              >
                <td>{{ translations.selectedTimes[lang] }}</td>
                <td>
                  <span
                    >{{ campaign.campaign_type_id_options.from_hour }}
                    -
                    {{ campaign.campaign_type_id_options.to_hour }}</span
                  >
                </td>
              </tr>
              <tr v-if="campaign.campaign_type_id_options.price_to_product !== undefined">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minAmountRule[lang] }}
                </td>
                <td>
                  <v-icon
                    v-if="campaign.campaign_type_id_options.price_to_product"
                    v-text="icons.mdiCheckCircle"
                    color="green"
                  ></v-icon>
                  <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
                </td>
              </tr>
              <tr v-if="campaign.campaign_type_id_options.execute_after_mins !== undefined">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.executeAfterMinutes[lang] }}
                </td>
                <td>{{ Number(campaign.campaign_type_id_options.execute_after_mins) }}'</td>
              </tr>
              <tr
                v-if="
                  campaign.campaign_type_id_options.execute_after_goal_completed_mins !== undefined
                "
              >
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.executeAfterGoalMinutes[lang] }}
                </td>
                <td>
                  {{ Number(campaign.campaign_type_id_options.execute_after_goal_completed_mins) }}'
                </td>
              </tr>

              <tr v-if="campaign.campaign_type_id_options.at_least_currency_spent">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minAmmount[lang] }}
                </td>
                <td>
                  {{ campaign.campaign_type_id_options.at_least_currency_spent }}
                </td>
              </tr>

              <tr v-if="campaign.campaign_type_id_options.at_least_points_won">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations[`atLeast_${storeMode}`][lang] }}
                </td>
                <td>
                  {{ campaign.campaign_type_id_options.at_least_points_won }}
                </td>
              </tr>
              <tr v-if="campaign.campaign_type_id_options.product_purchased_min_quantity">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minQuantity[lang] }}
                </td>
                <td>
                  {{ campaign.campaign_type_id_options.product_purchased_min_quantity }}
                </td>
              </tr>
              <tr
                v-if="campaign.campaign_type_id_options.maximum_number_of_entries_per_participant"
              >
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.maximumEntriesPerParticipant[lang] }}
                </td>
                <td>
                  {{ campaign.campaign_type_id_options.maximum_number_of_entries_per_participant }}
                </td>
              </tr>
              <tr v-if="campaign.campaign_type_id_options.minimum_transactions">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minimum_transactions[lang] }}
                </td>
                <td>
                  {{ campaign.campaign_type_id_options.minimum_transactions }}
                </td>
              </tr>
              <tr :style="{ background: '#eaedf1' }">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>

      <!-- <v-col cols="12" md="12" class="pa-6" style="background: #eaedf1;"></v-col> -->
    </v-row>

    <v-row>
      <v-col cols="12" md="12" class="d-flex">
        <span class="text-h5 pa-6 pl-12 pb-0 pt-0">{{
          translations.campaignConditions[lang]
        }}</span>
      </v-col>
      <v-col cols="12" md="12" class="">
        <v-simple-table v-if="currentCondition.system">
          <template v-slot:default>
            <thead :style="{ maxHeight: '1px' }">
              <tr>
                <th class="text-left" :style="{ maxHeight: '1px' }"></th>
                <th class="text-left" :style="{ maxHeight: '1px' }"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ translations.category[lang] }}</td>
                <td>
                  <span class="font-weight-bold px-1 d-flex align-center pr-0">
                    {{ translations[currentCondition.system + 'Condition'][lang] }}
                  </span>
                </td>
              </tr>
              <tr
                v-if="campaign.campaign_condition_id_options.number_of_transactions_after_campaign"
              >
                <td>
                  {{ translations.requiredTransactions[lang] }}
                </td>
                <td>
                  {{ campaign.campaign_condition_id_options.number_of_transactions_after_campaign }}
                </td>
              </tr>
              <!-- <tr v-if="campaign.campaign_condition_id_options.time">
                            <td>{{ translations.selectedTime[lang] }}</td>
                            <td>
                                {{ campaign.campaign_condition_id_options.time }}
                            </td>
                        </tr> -->

              <!-- <tr
                            v-if="
                                campaign.campaign_condition_id_options[0] &&
                                    campaign.campaign_condition_id_options[0]
                                        .date
                            "
                        >
                            <td>{{ translations.selectedDates[lang] }}</td>
                            <td>
                                <div
                                    v-for="(item,
                                    index) in campaign.campaign_condition_id_options"
                                    :key="index"
                                >
                                    <span
                                        >{{ localizeDate(item.date) }} -
                                        {{ item.time }}</span
                                    >
                                </div>
                            </td>
                        </tr> -->
              <tr
                v-if="
                  campaign.campaign_condition_id_options.transaction_types &&
                  campaign.campaign_condition_id_options.transaction_types[0]
                "
              >
                <td>
                  {{ translations.transactionTypes[lang] }}
                </td>
                <td>
                  <v-row class="d-flex justify-start ml-0 transition-all mw-100">
                    <v-col
                      v-for="(item, index) in campaign.campaign_condition_id_options
                        .transaction_types"
                      :key="index"
                      cols="12"
                      sm="12"
                      md="4"
                      class="d-flex flex-row justify-center align-center mt-0 pa-5 pt-2 pb-2 transition-all text-caption rounded-lg text-left mr-0"
                      :style="{
                        maxWidth: '120px',
                        maxHeight: '150px',
                        lineHeight: '0.75rem',
                      }"
                    >
                      <v-divider
                        v-if="index"
                        vertical
                        :style="{
                          minHeight: '66%',
                          alignSelf: 'center',
                        }"
                        class="mr-1 ml-1"
                      ></v-divider>
                      <v-icon
                        v-text="transactionTypesIcons[item.transaction_id]"
                        size="35"
                        color="secondary"
                      ></v-icon>
                      <span class="pa-1">{{ item.name[lang] }}</span>
                    </v-col>
                  </v-row>
                </td>
              </tr>

              <tr
                v-if="
                  campaign.campaign_condition_id_options.products &&
                  campaign.campaign_condition_id_options.products[0]
                "
              >
                <td>
                  {{ translations.products[lang] }}
                </td>
                <td>
                  <div class="d-flex">
                    <v-row
                      v-if="campaign.campaign_condition_id_options.products != '*'"
                      class="d-flex justify-start ml-0 transition-all mw-100"
                    >
                      <v-col
                        v-for="(item, index) in campaign.campaign_condition_id_options.products"
                        :key="index"
                        cols="12"
                        sm="12"
                        md="4"
                        class="d-flex flex-row justify-center align-center mt-0 pa-0 transition-all text-caption rounded-lg text-left mr-0"
                        :class="[index > 3 && 'display-none']"
                        :style="{
                          maxWidth: '120px',
                          maxHeight: '150px',
                          lineHeight: '0.75rem',
                        }"
                      >
                        <v-divider
                          v-if="index && index < 3"
                          vertical
                          :style="{
                            minHeight: '66%',
                            alignSelf: 'center',
                          }"
                          class="mr-1 ml-0"
                        ></v-divider>
                        <v-img
                          v-if="
                            item.image &&
                            item.image !=
                              'https://roadcube-stage-files.s3.eu-central-1.amazonaws.com/images/info/rc/no-image.png' &&
                            index < 3
                          "
                          contain
                          height="42"
                          width="42"
                          max-height="48"
                          max-width="48"
                          :src="item.image"
                          aspect-ratio="1"
                          class="grey lighten-2"
                        ></v-img>
                        <!-- <v-icon
                                                v-text="transactionTypesIcons[
                                                        item.transaction_id
                                                    ]"
                                                    size="35"
                                                color="secondary"
                                        ></v-icon> -->
                        <span v-if="index < 3" class="pa-1">{{ item.name[lang] }}</span>
                        <v-btn
                          v-if="index == 3"
                          class="ml-2"
                          color="secondary"
                          fab
                          x-small
                          dark
                          @click="
                            openList(campaign.campaign_condition_id_options.products, {
                              photo: true,
                              description: true,
                              title: translations.products[lang],
                            })
                          "
                        >
                          <v-icon>...</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <span v-else
                      >{{ translations.all[lang] }}
                      <!-- <v-btn
                                            color="secondary"
                                            dark
                                            class="ml-2"
                                            small
                                            @click="openList()"
                                            >{{ translations.more[lang] }}</v-btn
                                        > -->
                    </span>
                  </div>
                </td>
              </tr>

              <tr
                v-if="
                  campaign.campaign_condition_id_options.stores &&
                  campaign.campaign_condition_id_options.stores[0]
                "
              >
                <td>
                  {{ translations.selectedStores[lang] }}
                </td>
                <td>
                  <div class="d-flex">
                    <v-row
                      v-if="campaign.campaign_condition_id_options.stores != '*'"
                      class="d-flex justify-start ml-0 transition-all mw-100"
                    >
                      <v-col
                        v-for="(item, index) in campaign.campaign_condition_id_options.stores"
                        :key="index"
                        cols="12"
                        sm="12"
                        md="4"
                        class="d-flex flex-row justify-center align-center mt-0 pa-2 pr-0 pl-0 transition-all text-caption rounded-lg text-left mr-0"
                        :class="[index > 3 && 'display-none']"
                        :style="{
                          maxWidth: '120px',
                          maxHeight: '150px',
                          lineHeight: '0.75rem',
                        }"
                      >
                        <v-divider
                          v-if="index && index < 3"
                          vertical
                          :style="{
                            minHeight: '66%',
                            alignSelf: 'center',
                          }"
                          class="mr-auto ml-auto"
                        ></v-divider>
                        <span v-if="index < 3" class="pa-1 font-weight-medium text-center"
                          ><div class="pa-1 pb-2 pt-0 font-weight-light" v-if="item.store_code">
                            [{{ item.store_code }}]
                          </div>
                          {{ item.name }}</span
                        >
                        <v-btn
                          v-if="index == 3"
                          class="ml-2"
                          color="secondary"
                          fab
                          x-small
                          dark
                          @click="
                            openList([campaign.campaign_condition_id_options.stores], {
                              title: translations.selectedStores[lang],
                              nameField: 'name',
                            })
                          "
                        >
                          <v-icon>...</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <span v-else
                      >{{ translations.all[lang] }}
                      <!-- <v-btn
                                            color="secondary"
                                            dark
                                            class="ml-2"
                                            small
                                            @click="openList()"
                                            >{{ translations.more[lang] }}</v-btn
                                        > -->
                    </span>
                  </div>
                </td>
              </tr>

              <tr
                v-if="
                  campaign.campaign_condition_id_options.coupons &&
                  campaign.campaign_condition_id_options.coupons[0]
                "
              >
                <td>{{ translations.couponsSelected[lang] }}{{}}</td>
                <td>
                  <div class="d-flex">
                    <v-row
                      v-if="campaign.campaign_condition_id_options.coupons != '*'"
                      class="d-flex justify-start ml-0 transition-all mw-100"
                    >
                      <v-col
                        v-for="(item, index) in campaign.campaign_condition_id_options.coupons"
                        :key="index"
                        cols="12"
                        sm="12"
                        md="4"
                        class="d-flex flex-row justify-center align-center mt-0 pa-5 pt-2 pb-2 transition-all text-caption rounded-lg text-left mr-0"
                        :class="[index > 3 && 'display-none']"
                        :style="{
                          maxWidth: '120px',
                          maxHeight: '150px',
                          lineHeight: '0.75rem',
                        }"
                      >
                        <v-divider
                          v-if="index && index < 3"
                          vertical
                          :style="{
                            minHeight: '66%',
                            alignSelf: 'center',
                          }"
                          class="mr-1 ml-1"
                        ></v-divider>
                        <span v-if="index < 3" class="pa-1">{{ item.title }}</span>
                        <v-btn
                          v-if="index == 3"
                          class="ml-2"
                          color="secondary"
                          fab
                          x-small
                          dark
                          @click="
                            openList(campaign.campaign_condition_id_options.coupons, {
                              title: translations.couponsSelected[lang],
                              nameField: 'title',
                            })
                          "
                        >
                          <v-icon>...</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <span v-else>{{ translations.all[lang] }} </span>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  campaign.campaign_condition_id_options.period &&
                  campaign.campaign_condition_id_options.period.from_date
                "
              >
                <td>{{ translations.selectedDates[lang] }}</td>
                <td>
                  <span
                    >{{ localizeDate(campaign.campaign_condition_id_options.period.from_date) }}
                    <span v-if="campaign.campaign_condition_id_options.period.to_date"
                      >-
                      {{
                        localizeDate(campaign.campaign_condition_id_options.period.to_date)
                      }}</span
                    >
                  </span>
                </td>
              </tr>
              <tr
                v-if="
                  campaign.campaign_condition_id_options.from_hour &&
                  campaign.campaign_condition_id_options.to_hour
                "
              >
                <td>{{ translations.selectedTimes[lang] }}</td>
                <td>
                  <span
                    >{{ campaign.campaign_condition_id_options.from_hour }}
                    -
                    {{ campaign.campaign_condition_id_options.to_hour }}</span
                  >
                </td>
              </tr>
              <tr v-if="campaign.campaign_condition_id_options.price_to_product !== undefined">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minAmountRule[lang] }}
                </td>
                <td>
                  <v-icon
                    v-if="campaign.campaign_condition_id_options.price_to_product"
                    v-text="icons.mdiCheckCircle"
                    color="green"
                  ></v-icon>
                  <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
                </td>
              </tr>
              <tr v-if="campaign.campaign_condition_id_options.unique_users !== undefined">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.uniqueParticipants[lang] }}
                </td>
                <td>
                  <v-icon
                    v-if="campaign.campaign_condition_id_options.unique_users"
                    v-text="icons.mdiCheckCircle"
                    color="green"
                  ></v-icon>
                  <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
                </td>
              </tr>
              <tr v-if="campaign.campaign_condition_id_options.min_amount">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minAmount[lang] }}
                </td>
                <td>
                  {{ campaign.campaign_condition_id_options.min_amount }}
                </td>
              </tr>

              <tr
                v-for="campaign in campaign.campaign_condition_id_options.campaigns"
                :key="campaign.campaign_id"
              >
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.titleCampaign[lang] }}
                </td>
                <td style="font-weight: bold">
                  <router-link
                    :to="{
                      name: 'CampaignReport',
                      params: {
                        campaign_id: campaign.campaign_id,
                      },
                    }"
                    class="b-signin-link"
                  >
                    <span class="font-weight-bold px-1"
                      >#{{ campaign.campaign_id }} {{ campaign.title }}</span
                    ></router-link
                  >
                  <span v-if="campaign.from_date">: {{ campaign.from_date }}</span>
                  <span v-if="campaign.to_date"> - {{ campaign.to_date }}</span>
                </td>
              </tr>
              <tr v-if="campaign.campaign_condition_id_options.execute_after_mins !== undefined">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.executeAfterMinutes[lang] }}
                </td>
                <td>{{ Number(campaign.campaign_condition_id_options.execute_after_mins) }}'</td>
              </tr>
              <tr v-if="campaign.campaign_condition_id_options.minimum_transactions !== undefined">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minimum_transactions[lang] }}
                </td>
                <td>
                  {{ Number(campaign.campaign_condition_id_options.minimum_transactions) }}
                </td>
              </tr>
              <tr v-if="campaign.campaign_condition_id_options.at_least_currency_spent">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minAmmount[lang] }}
                </td>
                <td>
                  {{ campaign.campaign_condition_id_options.at_least_currency_spent }}
                </td>
              </tr>

              <tr v-if="campaign.campaign_condition_id_options.at_least_currency_spent">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minAmmount[lang] }}
                </td>
                <td>
                  {{ campaign.campaign_condition_id_options.at_least_currency_spent }}
                </td>
              </tr>
              <tr v-if="campaign.campaign_condition_id_options.product_purchased_min_quantity">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.minQuantity[lang] }}
                </td>
                <td>
                  {{ campaign.campaign_condition_id_options.product_purchased_min_quantity }}
                </td>
              </tr>
              <tr
                v-if="
                  campaign.campaign_condition_id_options.maximum_number_of_entries_per_participant
                "
              >
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.maximumEntriesPerParticipant[lang] }}
                </td>
                <td>
                  {{
                    campaign.campaign_condition_id_options.maximum_number_of_entries_per_participant
                  }}
                </td>
              </tr>

              <tr v-if="campaign.campaign_condition_id_options.lat">
                <td :style="{ maxWidth: '380px' }">
                  {{ translations.location[lang] }}
                </td>
                <td>
                  <v-btn color="secondary" dark class="ml-2" small @click="openMap()"
                    >{{ translations.openMap[lang] }}
                  </v-btn>
                </td>
              </tr>
              <tr :style="{ background: '#eaedf1' }">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <!-- <v-col cols="12" md="12" class="pa-6" style="background: #eaedf1;"></v-col> -->
    </v-row>
    <v-row v-if="campaign.campaign_client_characteristic_id && currentCharacteristics.system">
      <v-col cols="12" md="12" class="d-flex">
        <span class="text-h5 pa-6 pl-12 pb-0 pt-0">{{
          translations.customerCharacteristics[lang]
        }}</span>
      </v-col>
      <v-col cols="12" md="12" class="">
        <v-simple-table style="height: 100% !important">
          <template v-slot:default>
            <thead :style="{ maxHeight: '1px' }">
              <tr>
                <th class="text-left" :style="{ height: '1px' }"></th>
                <th class="text-left" :style="{ height: '1px' }"></th>
              </tr>
            </thead>
            <tbody style="height: 100% !important">
              <tr>
                <td>{{ translations.category[lang] }}</td>
                <td>
                  <span class="font-weight-bold px-1 d-flex align-center pr-0">
                    {{ translations[currentCharacteristics.system + 'Characteristic'][lang] }}
                  </span>
                </td>
              </tr>
              <tr v-if="campaign.campaign_client_characteristic_id_options.from_points_won">
                <td>{{ translations[storeMode][lang] }}</td>
                <td>
                  <span>{{ translations.from[lang] }}</span>
                  <span class="text-subtitle-2">{{
                    campaign.campaign_client_characteristic_id_options.from_points_won
                  }}</span>
                  <span v-if="campaign.campaign_client_characteristic_id_options.to_points_won"
                    >{{ '  ' + translations.to[lang] }}
                    <span class="text-subtitle-2">{{
                      campaign.campaign_client_characteristic_id_options.to_points_won
                    }}</span>
                  </span>
                </td>
              </tr>

              <tr v-if="campaign.campaign_client_characteristic_id_options.from_currency_spending">
                <td>{{ translations.amount[lang] }}</td>
                <td>
                  <span>{{ translations.from[lang] }}</span>
                  <span class="text-subtitle-2">{{
                    campaign.campaign_client_characteristic_id_options.from_currency_spending
                  }}</span>
                  <span
                    v-if="campaign.campaign_client_characteristic_id_options.to_currency_spending"
                    >{{ '  ' + translations.to[lang] }}
                    <span class="text-subtitle-2">{{
                      campaign.campaign_client_characteristic_id_options.to_currency_spending
                    }}</span>
                  </span>
                </td>
              </tr>

              <tr v-if="campaign.campaign_client_characteristic_id_options.from_transactions_done">
                <td>
                  {{ translations.transactionsNumber[lang] }}
                </td>
                <td>
                  <span>{{ translations.from[lang] }}</span>
                  <span class="text-subtitle-2">{{
                    campaign.campaign_client_characteristic_id_options.from_transactions_done
                  }}</span>
                  <span
                    v-if="campaign.campaign_client_characteristic_id_options.to_transactions_done"
                    >{{ '  ' + translations.to[lang] }}
                    <span class="text-subtitle-2">{{
                      campaign.campaign_client_characteristic_id_options.to_transactions_done
                    }}</span>
                  </span>
                </td>
              </tr>

              <tr v-if="campaign.campaign_client_characteristic_id_options.from_date">
                <td>{{ translations.selectedDates[lang] }}</td>
                <td>
                  <span
                    >{{
                      localizeDate(campaign.campaign_client_characteristic_id_options.from_date)
                    }}
                    <span v-if="campaign.campaign_client_characteristic_id_options.to_date"
                      >-
                      {{
                        localizeDate(campaign.campaign_client_characteristic_id_options.to_date)
                      }}</span
                    >
                  </span>
                </td>
              </tr>
              <tr v-if="currentGender.value">
                <td>{{ translations.gender[lang] }}</td>
                <td>
                  <v-icon v-text="currentGender.icon" size="35" color="secondary"></v-icon>
                  <span class="pa-1">{{ translations[currentGender['key']][lang] }}</span>
                </td>
              </tr>

              <tr v-if="campaign.campaign_client_characteristic_id_options.from_age">
                <td>{{ translations.selectedAges[lang] }}</td>
                <td>
                  <span v-if="campaign.campaign_client_characteristic_id_options.from_age"
                    >{{ translations.from[lang] }}
                    <span class="font-weight-bold">{{
                      campaign.campaign_client_characteristic_id_options.from_age
                    }}</span>
                  </span>
                  <span v-else-if="campaign.campaign_client_characteristic_id_options.to_age">{{
                    translations.uptoAge[lang]
                  }}</span>
                  <span v-if="campaign.campaign_client_characteristic_id_options.to_age">
                    {{ translations.to[lang] }}
                    <span class="font-weight-bold">{{
                      campaign.campaign_client_characteristic_id_options.to_age
                    }}</span>
                  </span>
                </td>
              </tr>

              <tr
                v-if="campaign.campaign_client_characteristic_id_options.has_birthday !== undefined"
              >
                <td>{{ translations.hasBirthday[lang] }}</td>
                <td>
                  <v-icon
                    v-if="campaign.campaign_client_characteristic_id_options.has_birthday"
                    v-text="icons.mdiCheckCircle"
                    color="green"
                  ></v-icon>
                  <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
                </td>
              </tr>

              <tr v-if="campaign.campaign_client_characteristic_id_options.store_point_title_ids">
                <td>
                  {{ translations.store_point_titleCharacteristic[lang] }}
                </td>
                <td>
                  <span>
                    {{ tierTitlesCommaSeparated }}
                  </span>
                </td>
              </tr>

              <tr v-if="campaign.campaign_client_characteristic_id_options.points">
                <td>
                  {{ translations[`${storeMode}_reachedCharacteristic`][lang] }}
                </td>
                <td>
                  <span>
                    <span class="font-weight-bold">{{
                      campaign.campaign_client_characteristic_id_options.points
                    }}</span>
                  </span>
                </td>
              </tr>
              <tr
                v-if="
                  campaign.campaign_client_characteristic_id_options.loyalty_program_ids &&
                  selectedLoyaltyPrograms[0]
                "
              >
                <td>
                  {{ translations.selectedLoyalties[lang] }}
                </td>
                <td>
                  <div class="d-flex">
                    <v-row class="d-flex justify-start ml-0 transition-all mw-100">
                      <v-col
                        v-for="(item, index) in selectedLoyaltyPrograms"
                        :key="index"
                        cols="12"
                        sm="12"
                        md="4"
                        class="d-flex flex-row justify-center align-center mt-0 pt-4 pb-4 pl-1 pr-1 transition-all text-caption rounded-lg text-left mr-0"
                        :class="[index > 3 && 'display-none']"
                        :style="{
                          maxWidth: '120px',
                          maxHeight: '150px',
                          lineHeight: '0.75rem',
                        }"
                      >
                        <div
                          style="max-width: 100%"
                          v-if="index < 3"
                          class="pa-1 font-weight-medium text-center"
                        >
                          <div class="pa-1 pb-2 pt-0 font-weight-light" v-if="item.logo">
                            <v-img contain height="36" :src="item.logo"></v-img>
                          </div>
                          <span class="pb-2">{{ item.points_label }} </span>
                        </div>
                        <v-btn
                          v-if="index == 3"
                          class="ml-2"
                          color="secondary"
                          fab
                          x-small
                          dark
                          @click="
                            openList(selectedLoyaltyPrograms, {
                              title: translations.selectedLoyalties[lang],
                              nameField: 'points_label',
                            })
                          "
                        >
                          <v-icon>...</v-icon>
                        </v-btn>
                        <v-divider
                          v-if="index && index < 3"
                          vertical
                          :style="{
                            minHeight: '66%',
                            alignSelf: 'center',
                          }"
                          class="mr-auto ml-auto"
                        ></v-divider>
                      </v-col>
                    </v-row>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  campaign.campaign_client_characteristic_id_options.user_account_attributes &&
                  selectedAccountAttributes[0]
                "
              >
                <td style="position: relative">
                  <div
                    :style="{
                      position: selectedAccountAttributes.length > 3 ? 'absolute' : 'relative',
                      top: '8px',
                    }"
                  >
                    <span>{{ translations.selectedAttributes[lang] }}</span>
                  </div>
                </td>
                <td style="height: 100% !important">
                  <div class="d-flex flex-column ml-0 transition-all">
                    <v-col
                      v-for="(item, index) in selectedAccountAttributes"
                      :key="index"
                      cols="12"
                      md="12"
                      class="mt-0 pb-4 pl-1 pr-1 transition-all text-caption rounded-lg text-left mr-0"
                      :class="[(!index && 'pt-4') || 'pt-0']"
                      :style="{
                        lineHeight: '0.75rem',
                      }"
                    >
                      <div
                        style="max-width: 100%"
                        v-if="item.attribute"
                        class="pa-1 font-weight-medium text-left"
                      >
                        <span class="pb-0 font-weight-bold">
                          {{ item.attribute.name }}
                        </span>

                        <span class="pb-0 ml-1 mr-2">
                          {{ translations[`operator${item.operator}`][lang] }}:
                        </span>
                        <span class="pb-0 font-weight-bold">
                          {{ item.selections.map((e) => e.value).join(', ') }}
                        </span>
                      </div>
                    </v-col>
                  </div>
                </td>
              </tr>
              <tr :style="{ background: '#eaedf1' }">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-dialog v-model="statusDialog" max-width="500">
      <b-card
        :title="translations.changeStatus[lang]"
        @cancel="() => (statusDialog = false)"
        @submit="changeStatus()"
        :loading="loading"
      >
        <b-select
          :items="campaignStatuses"
          :item-text="`name[${lang}]`"
          item-value="campaign_status_id"
          v-model="newStatus"
          label="Status"
        ></b-select>
      </b-card>
    </v-dialog>

    <v-dialog v-model="listDialog" max-width="500">
      <b-card
        :title="listOptions.title"
        @cancel="closeList()"
        :submitBtn="false"
        :loading="loading"
      >
        <v-list three-line>
          <template v-for="(item, index) in listItems">
            <v-divider v-if="index" :key="index + 'f'" inset></v-divider>

            <v-list-item :key="index" class="d-flex align-center">
              <v-list-item-avatar
                v-if="
                  item.logo ||
                  (item.image &&
                    item.image !=
                      'https://roadcube-stage-files.s3.eu-central-1.amazonaws.com/images/info/rc/no-image.png')
                "
              >
                <v-img :src="item.logo || item.image"></v-img>
              </v-list-item-avatar>
              <span v-else-if="item.image === undefined" class="text-h6 pa-2 text-center"
                >{{ index + 1 }}.</span
              >
              <v-list-item-content>
                <v-list-item-title class="text-h5"
                  ><span v-if="item.store_code">[{{ item.store_code }}]</span>
                  <span v-if="item[listOptions.nameField] && item[listOptions.nameField][lang]">{{
                    item[listOptions.nameField][lang]
                  }}</span>
                  <span v-else>{{ item[listOptions.nameField] }}</span>
                </v-list-item-title>
                <v-list-item-subtitle
                  v-if="item.description"
                  v-html="item.description[lang]"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </b-card>
    </v-dialog>

    <v-dialog v-model="mapDialog" max-width="500">
      <b-card
        :title="translations.location[lang]"
        @cancel="closeMap()"
        :submitBtn="false"
        :loading="loading"
      >
        <v-col cols="12" sm="12" md="12" class="d-flex flex-column align-center">
          <v-col cols="12" sm="12" md="12">
            <gmap-map
              :center="center"
              :zoom="
                Math.log2(
                  ((38000 *
                    Math.cos(
                      (Number(campaign.campaign_condition_id_options.lat) * Math.PI) / 180
                    )) /
                    Number(campaign.campaign_condition_id_options.radius)) *
                    1000
                ) - 10
              "
              :style="{
                width: '100%',
                height: '400px',
                minWidth: '400px',
              }"
              v-if="currentCondition.system == 'based_on_location'"
            >
              <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="() => (center = m.position)"
              ></gmap-marker>

              <GmapCircle
                v-for="(pin, index) in markers"
                :key="index + 1"
                :center="pin.position"
                :radius="Number(campaign.campaign_condition_id_options.radius * 1000)"
                :visible="true"
                :options="{
                  strokeColor: '#2596bea8',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: '#2596bea8',
                  fillOpacity: 0.35,
                }"
              ></GmapCircle>
            </gmap-map>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ translations.radius[lang] }}
                    </th>
                    <th class="text-left">
                      {{ campaign.campaign_condition_id_options.radius }}
                    </th>
                  </tr>
                </thead>
              </template>
            </v-simple-table>
          </v-col>
        </v-col>
      </b-card>
    </v-dialog>

    <v-dialog v-model="optionsDialog" max-width="1200" :style="{ width: '90%' }">
      <b-card
        :title="translations.changeTypeOptions[lang]"
        @cancel="() => (optionsDialog = false)"
        @submit="changeOptions()"
        :disabled="!canGoToNextStep"
        :loading="loading"
      >
        <CampaignTypeOptions mode="update" />
      </b-card>
    </v-dialog>

    <v-dialog v-model="updateBillableDialog" max-width="500">
      <b-card
        :title="translations.billableText[lang]"
        :loading="loading"
        :type="newBillable ? 'success' : 'delete'"
        :theme="newBillable ? 'green' : 'error'"
        :submit-text="translations.submit"
        @cancel="updateBillableDialog = false"
        @submit="doUpdateBilling({ id: campaign.campaign_id, billable: newBillable })"
      >
        <span class="subtitle-1 font-weight-medium pl-2">
          {{ translations.confirmationMessageSure[lang] }}
        </span>
        <span class="subtitle-1 text-center font-weight-bold">
          <span v-if="newBillable">{{ translations.confirmBilling[lang] }}</span>
          <span v-else>{{ translations.cancelBilling[lang] }}</span>
        </span>
        {{ translations.questionmark[lang] }}
      </b-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  mdiBell,
  mdiEmailOutline,
  mdiMessageTextOutline,
  mdiBellOutline,
  mdiArrowRight,
  mdiCheckCircle,
  mdiCloseCircle,
  mdiGift,
  mdiAccountGroup,
  mdiTextBox,
  mdiArrowLeft,
  mdiBullhorn,
  mdiAccountArrowRight,
  mdiCalendar,
  mdiCartArrowDown,
  mdiCashPlus,
  mdiCalendarMultiple,
  mdiCalendarRefresh,
  mdiCached,
  mdiCellphoneSound,
  mdiPrinterPos,
  mdiStore,
  mdiAndroid,
  mdiApi,
  mdiGenderMale,
  mdiGenderFemale,
  mdiGenderMaleFemale,
  mdiBasketUnfill,
  mdiBullseyeArrow,
  mdiCogSync,
  mdiCashCheck,
  mdiCashRemove,
} from '@mdi/js';
import { mapMutations, mapState, mapActions } from 'vuex';

import translations from '@/utils/translations/loyaltyPanel/campaigns/viewCampaigns';
import { Icon } from '@iconify/vue2';
import CampaignTypeOptions from '@/components/loyaltyPanel/newCampaign/Step2Type';

export default {
  name: 'GeneralInfoReport',

  mixins: [translations],

  components: {
    Icon,
    CampaignTypeOptions,
  },
  data() {
    return {
      icons: {
        mdiBell,
        mdiEmailOutline,
        mdiMessageTextOutline,
        mdiBellOutline,
        mdiArrowRight,
        mdiCheckCircle,
        mdiCloseCircle,
        mdiAccountGroup,
        mdiGift,
        mdiCached,
        mdiTextBox,
        mdiArrowLeft,
        mdiCogSync,
        mdiCashCheck,
        mdiCashRemove,
        types: {
          informative: mdiBullhorn,
          action: mdiAccountArrowRight,
          one_time_execution: mdiCalendar,
          repeat_execution: mdiCalendarRefresh,
          multiple_times_execution: mdiCalendarMultiple,
          new_transaction: mdiCashPlus,
          transaction_with_specific_products: mdiCartArrowDown,
          draw: mdiBasketUnfill,
          transaction_goal: mdiBullseyeArrow,
        },
      },
      transactionTypesIcons: {
        4: mdiCellphoneSound,
        5: mdiPrinterPos,
        10: mdiStore,
        11: mdiAndroid,
        17: mdiApi,
      },
      changingStatusCampaignId: null,
      statusDialog: false,
      listDialog: false,
      listItems: [],
      listOptions: {
        title: '',
        nameField: 'name',
      },
      newStatus: null,
      notificationIcons: {
        sms: mdiMessageTextOutline,
        mail: mdiEmailOutline,
        push: mdiBellOutline,
        viber: 'simple-icons:viber',
      },
      weekdays: [
        { name: 'sunday', value: 0 },
        { name: 'monday', value: 1 },
        { name: 'tuesday', value: 2 },
        { name: 'wednesday', value: 3 },
        { name: 'thursday', value: 4 },
        { name: 'friday', value: 5 },
        { name: 'saturday', value: 6 },
      ],
      mapDialog: false,
      markers: [],
      genders: [
        {
          key: 'male',
          icon: mdiGenderMale,
          value: 1,
        },
        {
          key: 'female',
          icon: mdiGenderFemale,
          value: 2,
        },
        {
          key: 'other',
          icon: mdiGenderMaleFemale,
          value: 3,
        },
      ],
      optionsDialog: false,

      updateBillableDialog: false,
      newBillable: null,
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'serverItemsLength', 'isSuperAdmin', 'superUser']),
    ...mapState('loyaltyPanel/campaigns/viewCampaigns', [
      'campaignStatuses',
      'systemNotifications',
      'campaign',
      'campaignTypes',
      'campaignConditions',
      'clientCharacteristics',
    ]),
    ...mapState('loyaltyPanel/campaigns/newCampaign', ['canGoToNextStep', 'newCampaign']),
    ...mapState('loyaltyPanel/pointTitles', ['tiers']),
    ...mapState('loyaltyPanel/customers', ['attributes']),
    lang() {
      return this.$route.params.lang;
    },

    locale() {
      if (this.lang == 'el') return 'el-GR';
      if (this.lang == 'it') return 'it-IT';
      return 'en-GB';
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    campaignId() {
      return this.$route.params.campaign_id;
    },

    campaignType() {
      let type = { name: '', value: {} };
      Object.keys(this.campaignTypes).forEach((key) => {
        let foundType = this.campaignTypes[key]?.campaign_types.find(
          (x) => this.campaign.campaign_type_id == x.campaign_type_id
        );
        if (foundType) {
          type.name = key;
          type.value = foundType;
        }
      });
      return type;
    },

    hasReward() {
      return Boolean(
        this.campaign?.reward?.coupon?.coupon_id ||
          this.campaign?.reward?.reward_points ||
          this.campaign?.reward?.multi_points_ratio
      );
    },

    currentStatus() {
      return (
        this.campaignStatuses.find(
          (x) => x.campaign_status_id == this.campaign?.campaign_status_id
        ) || {
          name: {
            el: 'Υπό εξέταση',
            en: 'Under review',
            it: 'In fase di revisione',
          },
        }
      );
    },

    currentNotifications() {
      let channels = [];
      if (this.campaign.system_notification_ids?.length) {
        this.campaign.system_notification_ids.forEach((e) => {
          let foundChannel = (this.systemNotifications || []).find(
            (x) => x.system_notification_id == e
          );
          if (foundChannel) channels.push(foundChannel);
        });
      }
      return channels;
    },

    currentCondition() {
      return (
        this.campaignConditions.find(
          (x) => x.campaign_condition_id == this.campaign.campaign_condition_id
        ) || {}
      );
    },

    clientCharacteristicsWithTranslations() {
      return (
        this.clientCharacteristics?.filter(
          (e) => this.translations[e.system + 'Characteristic']?.[this.lang]
        ) || []
      );
    },
    currentCharacteristics() {
      return (
        this.clientCharacteristicsWithTranslations.find(
          (x) =>
            x.campaign_client_characteristic_id == this.campaign.campaign_client_characteristic_id
        ) || {}
      );
    },
    tierTitlesCommaSeparated() {
      return this.tiers
        .filter((tier) =>
          this.campaign.campaign_client_characteristic_id_options?.store_point_title_ids.includes(
            tier.store_point_title_id
          )
        )
        .map((tier) => tier.title[this.lang])
        .join(', ');
    },
    currentTransactionTypes() {
      return this.campaign.campaign_type_id_options?.transaction_types || [];
    },

    currentGender() {
      return (
        this.genders.find(
          (x) => x.value == this.campaign.campaign_client_characteristic_id_options.gender
        ) || {}
      );
    },
    repeatDays() {
      let activeDays = [];
      for (let [i, time] of (
        this.campaign.campaign_type_id_options?.repeat_day_times || []
      ).entries()) {
        if (time) {
          let day = this.weekdays.find((x) => x.value == i);
          activeDays.push({ day, time });
        }
      }
      return activeDays;
    },

    loyalties() {
      return this.$store.state.loyaltyPanel.campaigns.newCampaign.loyalties;
    },

    selectedLoyaltyPrograms() {
      return (
        this.loyalties?.filter((e) =>
          this.campaign.campaign_client_characteristic_id_options.loyalty_program_ids.includes(
            e.loyalty_program_id
          )
        ) || []
      );
    },

    selectedAccountAttributes() {
      return this.campaign.campaign_client_characteristic_id_options.user_account_attributes?.map(
        (e) => {
          let attribute =
            this.attributes.find(
              (x) =>
                x.user_account_attribute_definition_id == e.user_account_attribute_definition_id
            ) || {};
          let selections =
            attribute.user_account_attribute_definition_values?.filter((x) =>
              e.user_account_attribute_definition_value_ids.includes(
                x.user_account_attribute_definition_value_id
              )
            ) || [];
          return { attribute, selections, operator: e.operator };
        }
      );
    },
    campaignProducts() {
      let products = {};
      if (this.campaign.campaign_type_id_options?.products?.[0]) {
        products['x0'] = this.campaign.campaign_type_id_options.products;
      }
      if (this.campaign.campaign_type_id_options?.products?.['_1']) {
        products['x1'] = this.campaign.campaign_type_id_options.products._1;
      }
      if (this.campaign.campaign_type_id_options?.products?.['_2']) {
        products['x2'] = this.campaign.campaign_type_id_options.products._2;
      }
      return products;
    },
  },

  watch: {
    ['campaign.campaign_type_id'](val) {
      if (val) {
        if (!this.campaignConditions?.length) {
          this.getCampaignConditions(val);
        }
        if (!this.clientCharacteristics?.length) {
          this.getClientCharacteristics(val);
        }
      }
    },

    currentStatus: {
      immediate: true,
      handler(val) {
        if (val) {
          this.campaign.status = val;
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/campaigns/viewCampaigns', [
      'changeCampaignStatus',
      'getCampaignStatuses',
      'getCampaignSystemNotifications',
      'getClientCharacteristics',
      'getCampaignConditions',
      'updateCampaignTypeOptions',
      'updateBilling',
    ]),
    ...mapMutations(['setNotification']),
    ...mapMutations('loyaltyPanel/campaigns/newCampaign', ['setNewCampaign']),
    ...mapActions('loyaltyPanel/campaigns/newCampaign', ['getLoyalties']),
    ...mapActions('loyaltyPanel/pointTitles', ['fetchPointTitles']),
    ...mapActions('loyaltyPanel/customers', ['getAttributes']),
    ...mapMutations('loyaltyPanel/customers', ['setAttributes']),

    openStatusDialog() {
      this.newStatus = this.currentStatus.campaign_status_id;
      this.statusDialog = true;
      this.changingStatusCampaignId = this.campaignId;
    },
    openTypeOptionsDialog() {
      this.campaign.category = this.campaignType.name;
      this.campaign.campaign_type_system = this.campaignType.value.system;
      // if(this.campaign.campaign_type_id_options?.from_hour){
      //     this.campaign.campaign_type_id_options.from_hour = '01:23'
      // }
      // if(this.campaign.campaign_type_id_options?.to_hour){
      //     this.campaign.campaign_type_id_options.to_hour = '23:45'
      // }
      this.setNewCampaign(this.campaign);
      this.optionsDialog = true;
    },
    async changeOptions() {
      let body = {
        campaign_type_id_options: this.newCampaign.campaign_type_id_options,
      };
      let data = {
        campaign_id: this.campaign.campaign_id,
        body: body,
      };
      await this.updateCampaignTypeOptions(data);
      this.optionsDialog = false;
      this.setNewCampaign({});
    },

    localizeDate(date, short) {
      return date
        ? new Date(date).toLocaleString(this.locale, {
            weekday: short ? undefined : 'long',
            year: 'numeric',
            month: short ? 'numeric' : 'long',
            day: 'numeric',
          })
        : '-';
    },

    async changeStatus() {
      let body = {
        campaign_status_id: this.newStatus,
      };
      let data = {
        campaign_id: this.changingStatusCampaignId,
        body: body,
      };
      await this.changeCampaignStatus(data);
      this.statusDialog = false;
      this.newStatus = null;
      this.changingStatusCampaignId = null;
    },

    filterCampaignChannels(ids) {
      return this.systemNotifications.filter((e) => ids.includes(e.system_notification_id));
    },
    openMap(val) {
      this.mapDialog = true;
      this.addMarker();
    },
    closeMap(val) {
      this.mapDialog = false;
      this.markers = [];
    },
    openList(items, options) {
      this.listItems = items;
      this.listOptions = { ...this.listOptions, ...options };
      this.listDialog = true;
    },
    closeList() {
      this.listDialog = false;
      this.listItems = [];
      this.listOptions = {
        title: '',
        nameField: 'name',
      };
    },

    addMarker() {
      if (this.campaign.campaign_condition_id_options?.lat) {
        const marker = {
          lat: this.campaign.campaign_condition_id_options?.lat,
          lng: this.campaign.campaign_condition_id_options?.lon,
        };
        this.markers = [];
        this.markers.push({ position: marker });
        this.center = marker;
      }
    },
    verifyUpdateBilling(billable) {
      this.newBillable = billable;
      this.updateBillableDialog = true;
    },
    async doUpdateBilling(payload) {
      let res = await this.updateBilling(payload);
      this.setNotification({
        show: true,
        type: res.error ? 'error' : 'success',
        text: res.message.replace(/_/g, ' '),
      });
      this.updateBillableDialog = false;
    },
  },

  mounted() {
    this.fetchPointTitles();
    if (
      !this.attributes?.length ||
      this.attributes[0]?.store_id !== localStorage.getItem('storeId')
    ) {
      this.setAttributes([]);
      this.getAttributes();
    }
    if (!this.campaignStatuses?.length) {
      this.getCampaignStatuses();
    }
    if (!this.systemNotifications?.length) {
      this.getCampaignSystemNotifications();
    }
    if (!this.loyalties?.length) {
      this.getLoyalties({ page: 1 });
    }
  },
};
</script>

<style scoped>
.border-grey {
  border: 2px solid grey;
}

.b-outlined {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.icon-container {
  /* margin-top:20px; */
  height: 200px;
  width: 200px;
}

.select-category {
  cursor: pointer;
  transition: all 0.5s ease-out;
  background-color: white;
  min-width: 200px;
  font-size: 22px;
  color: gray;
  /* border: 1px solid black */
}

.select-category:hover {
  background-color: rgba(0, 0, 0, 0.2);
  color: black;
  /* font-size: 26px; */
}

.invisible {
  opacity: 0;
  z-index: 0;
}

.overlapped {
  position: absolute;
}

.transition-all {
  transition:
    all 1.5s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 1s,
    background-color 2s;
}

.back-button {
  position: absolute;
  top: 45%;
  z-index: 10;
}

.mw-100 {
  min-width: 100% !important;
}

.mw-180 {
  min-width: 180px !important;
}

.b-outlined {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.selected-condition {
  color: white;
  background: #272727;
  border-color: #272727;
}

.selected-condition .v-icon {
  background: white;
  color: #272727;
}

.selected-condition .border-grey {
  border-color: #272727;
}

.mw-100 {
  min-width: 100% !important;
}

.mw-180 {
  min-width: 180px !important;
}

.display-none {
  display: none !important;
}
</style>
<style>
.selected-stores .v-slide-group__content {
  display: flex;
  justify-content: space-evenly;
}
</style>
